/* =========================================================================
   KENZA FOOTER v1 — JS
   - Mobile accordion (close all by default, tap to open)
   - Newsletter form button state on submit
   ========================================================================= */
(function () {
  'use strict';

  function init() {
    const footer = document.querySelector('.kenza-footer');
    if (!footer) return;

    // Mobile accordion: close all <details> by default on mobile width
    const mobileMql = window.matchMedia('(max-width: 768px)');
    const detailsList = footer.querySelectorAll('.kenza-footer__details[data-acc]');

    function applyMobileState() {
      const isMobile = mobileMql.matches;
      detailsList.forEach((d) => {
        if (isMobile) {
          d.removeAttribute('open');
        } else {
          d.setAttribute('open', '');
        }
      });
    }
    applyMobileState();
    if (mobileMql.addEventListener) {
      mobileMql.addEventListener('change', applyMobileState);
    } else if (mobileMql.addListener) {
      mobileMql.addListener(applyMobileState);
    }

    // Newsletter form: disable button on submit, show loading
    const form = footer.querySelector('.kenza-footer__newsletter-form');
    if (form) {
      form.addEventListener('submit', function () {
        const btn = form.querySelector('.kenza-footer__newsletter-button');
        if (btn) {
          btn.disabled = true;
          btn.style.opacity = '0.7';
          const span = btn.querySelector('span');
          if (span) {
            btn.dataset.originalText = span.textContent;
            span.textContent = 'Bezig…';
          }
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.kenza-footer')) init();
  });
})();